import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";


export default class PageGeneric extends PageCommon {
	constructor() {
		super();
	}
    init($data ) {
        super.init( $data );
		this.showPreloader(false);
		Pqp.trace("PageGeneric - Hello world"); 
    this.initAccordion();
    this.initCarousel();
		// dispaccio un evento globale
		this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
	}

  initAccordion() {

    $('.js-accordion').click(function (e) {
      e.preventDefault();

      var $this = $(this);
      var el = $this.parent();
      console.log($this);
      el.toggleClass("open");
      $(".accordion-content", el).slideToggle('swing')

    });
  }

  initCarousel() {
    $(".js-carousel").owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      dots: false,
      items: 4,
      navText: ["<", ">"],
      responsive: {
        0: {
          items: 1
        },
        900: {
          items: 2
        },
        1000: {
          items: 4
        }
      }
    })
  }



}

